<template>
  <v-flex>
    <v-row>
      <v-col>
        <h3 class="light-blue--text darken-4">Visualize changes</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" :md="6" :lg="6" :sm="12">
        <v-select v-model="rangeDate" label="Dates to compare" item-text="name" :items="getRangeDates"
                  @input="updateAllMockData"></v-select>
      </v-col>
      <v-col cols="6" :md="6" :lg="6" :sm="12">
        <v-chip-group column class="hidden-xs-only">
          <v-chip v-for="(section, key) in scrapedProfileSections"
                  :key="key"
                  label
                  small
                  :disabled="profileHasNotChanges(section)"
                  :color="getChipColor(section)"
                  :text-color="getChipColorText(section)"
                  @click="scrollTo(section.section, $event)"

          >
            {{section.section}}
          </v-chip>
        </v-chip-group>
        <v-select class="hidden-sm-and-up"
          v-model="selectedSection" label="Navigate to section"
          item-disabled="disabled"
          item-text="section"
          :items="availableSections"
          @input="scrollToWithSelect">
          <template v-slot:item="{item}">
            <span :style="`color: ${getChipColor(item)}`">{{item.section}}</span>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <lin-profile-mockup
      id="lin-profile-mockup"
      :style="getStyle"
      class="overflow-y-auto"
      :scraped-profile="mockData"
      :delta="delta"
      v-if="mockData"></lin-profile-mockup>
  </v-flex>
</template>

<script>
  import moment from 'moment';
  import LinProfileMockup from "../Mockers/linProfileMockup";
  import {scrapedProfileSections} from "../../constants/constants";


  export default {
    name: "visualizeChanges",
    components: {LinProfileMockup},
    props: ['profile'],
    data() {
      return {
        rangeDate: undefined,
        delta: undefined,
        mockData: undefined,
        selectedSection:undefined,
        scrapedProfileSections: scrapedProfileSections,
        availableSections: scrapedProfileSections
      }
    },
    mounted() {
      this.updateAllMockData(this.getRangeDates[0].value);
    },
    methods: {
      updateAllMockData(event) {
        this.rangeDate = event;
        this.mockData = this.profile.history[event];
        this.delta = this.profile.edges.market.profileChanges.slice().reverse()[event];
        this.availableSections = this.scrapedProfileSections.map(e => {
          return {
            section: e.section,
            colorFill: this.getChipColor(e),
            colorLine: e.colorLine,
            textColor: e.textColor,
            disabled: this.profileHasNotChanges(e)
          }
        })
      },
      getChipColor(section) {
        return this.profileHasSection(section.section) ? section.colorFill : '#aaa';
        // return section.colorFill;
      },
      getChipColorText(section) {
        return this.profileHasSection(section.section) ? section.textColor : '#000';
        // return section.textColor;
      },
      profileHasSection(section){
        return this.profile.scrapedProfile[section] !== undefined
          && this.profile.scrapedProfile[section] !== false
          && Object.keys(this.profile.scrapedProfile[section]).length > 0
      },
      profileHasNotChanges(section){
        return this.delta !== undefined && this.delta[section.section] === undefined ;
      },
      scrollTo(section, $event){
        $event.preventDefault();
        document.getElementById(`${section}Mockup`).scrollIntoView({
          behavior: 'smooth'
        });
      },
      scrollToWithSelect(section){
        document.getElementById(`${section}Mockup`).scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    computed: {
      getRangeDates() {
        const range = [];
        for (let k = 0; k < this.profile.history.length - 1; k++) {
          let history = this.profile.history;
          range.push(
            {
              value: k,
              name: `${moment(history[k].scrapedDate).format('DD-MMM')} - ${moment(history[k + 1].scrapedDate).format('DD-MMM')}`
            }
          )
        }
        return range;
      },
      getStyle(){
        return `max-height: ${(window.innerHeight - 190)}px`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/visualizeChanges.vue